import { render, staticRenderFns } from "./defaultDashboard.vue?vue&type=template&id=68d9427a&"
import script from "./defaultDashboard.vue?vue&type=script&lang=js&"
export * from "./defaultDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports